import { Instagram, Mail, ArrowUpRight } from "lucide-react";
import { LINKS, NAV_ITEMS } from "@/lib/site";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#0B1F3A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#home" className="flex items-center gap-3">
              <img
                src="/assets/logo.jpeg"
                alt="Nexfold Consults"
                className="h-11 w-11 rounded-lg object-cover ring-1 ring-white/10"
              />
              <span className="font-display text-xl font-extrabold tracking-tight">
                Nexfold <span className="font-medium text-[#C8A75D]">Consults</span>
              </span>
            </a>
            <p className="font-display mt-6 max-w-sm text-2xl font-semibold tracking-tight leading-snug text-white/90">
              Turning Ambition Into Achievement.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C8A75D]">
              Quick Links
            </p>
            <ul className="mt-6 space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    data-testid={`footer-link-${item.label.toLowerCase()}`}
                    className="text-sm text-white/70 transition-colors duration-300 hover:text-[#C8A75D]"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C8A75D]">
              Connect
            </p>
            <div className="mt-6 space-y-4">
              <a
                href={LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="group flex items-center gap-3 text-sm text-white/70 transition-colors duration-300 hover:text-[#C8A75D]"
              >
                <Instagram className="h-5 w-5" />
                @nexfoldconsults
                <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </a>
              <a
                href={`mailto:${LINKS.email}`}
                data-testid="footer-email"
                className="group flex items-center gap-3 text-sm text-white/70 transition-colors duration-300 hover:text-[#C8A75D]"
              >
                <Mail className="h-5 w-5" />
                {LINKS.email}
              </a>
            </div>
            <a
              href={LINKS.instagramDM}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-book-consultation-footer"
              className="group mt-8 inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:border-[#C8A75D] hover:text-[#C8A75D]"
            >
              Book a Consultation
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/50">
            © 2026 Nexfold Consults Limited. All rights reserved.
          </p>
          <p className="text-xs uppercase tracking-[0.18em] text-white/40">
            United Kingdom
          </p>
        </div>
      </div>
    </footer>
  );
}
